import { ForwardRefExoticComponent, forwardRef } from 'react';
import Box, { type BoxProps } from '@mui/material/Box';

export type IconProps = Omit<BoxProps<'svg'>, 'component' | 'ref'> & {
  size?: number | string;
};

export type IconElementWithRef = ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
>;

export type IconElement = IconElementWithRef | React.ComponentType<IconProps>;

const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, ...props }, ref) => (
    <Box
      component="svg"
      width={size}
      height={size}
      flexShrink={0}
      aria-hidden={props['aria-label'] ? undefined : true}
      ref={ref}
      {...props}
    />
  )
);

export default Icon;
